import React from 'react';
import { useSelector } from 'react-redux';

import { errorConfigSelector } from '@src/store/errorLogicConfig/configContainer/selectors';
import FilterRow from './FilterRow';
import { RowWrapper } from '../styled';

function FilterRowGroup() {
  const config = useSelector(errorConfigSelector);
  const orRuleGroup = config.rules;
  const canDel = orRuleGroup.length > 1 || orRuleGroup[0].length > 1;
  return (
    <RowWrapper>
      {orRuleGroup.map((orRule, idx1) => (
        <FilterRow
          key={`${orRule.field}-${idx1}`} // eslint-disable-line react/no-array-index-key
          lookup={`${idx1}`}
          rule={orRule}
          canDel={canDel}
        />
      ))}
    </RowWrapper>
  );
}

export default FilterRowGroup;
